
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/robots.txt",
      function () {
        return require("private-next-pages/robots.txt.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/robots.txt"])
      });
    }
  